// libs
import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { ClockOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
// components
import { Box, Typography } from '@lyearn/ui';
// hooks
import { useContentDetails } from '@/components/ContentDetails/context';
// types
import { ContentDetailsItemProps } from '@/components/ContentDetails/types';
// utils
import getHumanDuration from '@/utils/time/getHumanDurationRounded';

function Duration(props: ContentDetailsItemProps) {
  const { className } = props;
  const { t } = useTranslation();
  const { content } = useContentDetails();

  if (!content.duration) {
    return null;
  }

  return (
    <Box
      className={cn(
        'flex h-40 w-max items-center justify-center rounded-8 border border-border ps-8 pe-12 xs:flex-row xs:px-12',
        className,
      )}>
      <ClockOutline className="h-20 w-20 me-8" fillColorToken="icon-secondary" />
      <Typography className="whitespace-pre text-text-primary" variant="body-short-02">
        {/* whitespace-pre: safari issue - breaking into multiline in some cases */}
        {t('Common:Duration')}: {getHumanDuration(content.duration)}
      </Typography>
    </Box>
  );
}

export default React.memo(Duration);
